export default __webpack_public_path__ + "static/media/modal-habeas-data.98a176b5.png";